import gql from "graphql-tag";

export default gql`
  mutation UpdateProductShowInShop($productId: ID!, $showInShop: Boolean!) {
    updateProduct(id: $productId, showInShop: $showInShop) {
      id
    }
  }
`;
